import { BaseModel } from '../../models/base.model';
import { CDNCode } from '../../shared-enums/cdn-code.enum';

export class NavTitle extends BaseModel<NavTitle> {

    public title: string;

    public key: string;

    public infoTitle: string;
    
    public videoKey: string;

    public videoKeys: string[];

    public matIcon: string;

    public cdnCode: CDNCode[] | CDNCode;

    constructor(def?: Partial<NavTitle>) {
        super({
            videoKeys: undefined,
            videoKey: undefined,
            infoTitle: undefined,
            title: undefined,
            key: undefined,
            matIcon: undefined,
            cdnCode: undefined
        }, def);
    }
}
